<template>
    <nav class="sub-sub-menu-nav" :class="{ subgroup: subgroup && subgroup.title }">
        <ul class="sub-sub-menu">
            <li class="sub-sub-menu-item" v-if="group && group.title">
                <router-link
                    class="sub-sub-menu-item-link back-link"
                    :to="{ name: 'SiteAdminGroupSubgroups', params: { groupId: group.id } }"
                    @click.prevent="gotoRoute({ name: 'SiteAdminGroupSubgroups', params: { groupId: group.id } })"
                >
                    <span
                        class="text-sm md:text-base font-bold text-primary m-0 my-2 sm:my-0 flex items-center
                          "
                    >
                        <IconOrg class="sub-sub-menu-item-icon" /><span
                            class="text-ellipsis overflow-hidden whitespace-nowrap inline-block max-w-xs"
                            >{{ group.title }}</span
                        >
                    </span>
                </router-link>
            </li>
            <template v-if="subgroup && subgroup.title">
                <li class="sub-sub-menu-item">
                    <span class="text-sm md:text-base font-bold text-secondary m-0 my-2 sm:my-0 px-4">
                        <IconService class="sub-sub-menu-item-icon" />{{ subgroup.title }}
                    </span>
                </li>
                <li class="sub-sub-menu-item">
                    <router-link
                        class="sub-sub-menu-item-link subgroup"
                        :to="{
                            name: 'SiteAdminGroupSubgroupVirtualGroups',
                            params: { groupId: group.id, subgroupId: subgroup.id }
                        }"
                        @click.prevent="
                            gotoRoute({
                                name: 'SiteAdminGroupSubgroupVirtualGroups',
                                params: { groupId: group.id, subgroupId: subgroup.id }
                            })
                        "
                        title="Upcoming Pharmacist-led Courses"
                        ><IconCourse class="sub-sub-menu-item-icon text-green-700" />Upcoming
                        PLEDs</router-link
                    >
                </li>
                <li class="sub-sub-menu-item">
                    <router-link
                        class="sub-sub-menu-item-link subgroup"
                        :to="{
                            name: 'SiteAdminGroupSubgroupHistoricVirtualGroups',
                            params: { groupId: group.id, subgroupId: subgroup.id }
                        }"
                        @click.prevent="
                            gotoRoute({
                                name: 'SiteAdminGroupSubgroupHistoricVirtualGroups',
                                params: { groupId: group.id, subgroupId: subgroup.id }
                            })
                        "
                        title="Past Pharmacist-led Courses"
                        ><IconCourse class="sub-sub-menu-item-icon text-gray-400" />Past
                        PLEDs</router-link
                    >
                </li>
                <li class="sub-sub-menu-item">
                    <router-link
                        class="sub-sub-menu-item-link subgroup"
                        :to="{
                            name: 'SiteAdminGroupSubgroupMembers',
                            params: { groupId: group.id, subgroupId: subgroup.id }
                        }"
                        @click.prevent="
                            gotoRoute({
                                name: 'SiteAdminGroupSubgroupMembers',
                                params: { groupId: group.id, subgroupId: subgroup.id }
                            })
                        "
                        ><IconUserGroup class="sub-sub-menu-item-icon" />Members</router-link
                    >
                </li>
                <li class="sub-sub-menu-item">
                    <router-link
                        class="sub-sub-menu-item-link subgroup"
                        :to="{
                            name: 'SiteAdminGroupSubgroupLicences',
                            params: { groupId: group.id, subgroupId: subgroup.id }
                        }"
                        @click.prevent="
                            gotoRoute({
                                name: 'SiteAdminGroupSubgroupLicences',
                                params: { groupId: group.id, subgroupId: subgroup.id }
                            })
                        "
                        ><IconLicence class="sub-sub-menu-item-icon" />Licences</router-link
                    >
                </li>
            </template>
            <template v-else-if="group && group.title">
                <li class="sub-sub-menu-item">
                    <router-link
                        class="sub-sub-menu-item-link"
                        :to="{ name: 'SiteAdminGroupSubgroups', params: { groupId: group.id } }"
                        @click.prevent="gotoRoute({ name: 'SiteAdminGroupSubgroups', params: { groupId: group.id } })"
                        ><IconService class="sub-sub-menu-item-icon" />{{ $t("Subgroups") }}</router-link
                    >
                </li>
                <li class="sub-sub-menu-item">
                    <router-link
                        class="sub-sub-menu-item-link"
                        :to="{ name: 'SiteAdminGroupVirtualGroups', params: { groupId: group.id } }"
                        @click.prevent="
                            gotoRoute({ name: 'SiteAdminGroupVirtualGroups', params: { groupId: group.id } })
                        "
                        title="Upcoming Pharmacist-led Courses"
                        ><IconCourse class="sub-sub-menu-item-icon text-green-700" />Upcoming
                        PLEDs</router-link
                    >
                </li>
                <li class="sub-sub-menu-item">
                    <router-link
                        class="sub-sub-menu-item-link"
                        :to="{ name: 'SiteAdminGroupHistoricVirtualGroups', params: { groupId: group.id } }"
                        @click.prevent="
                            gotoRoute({
                                name: 'SiteAdminGroupHistoricVirtualGroups',
                                params: { groupId: group.id }
                            })
                        "
                        title="Past Pharmacist-led Courses"
                        ><IconCourse class="sub-sub-menu-item-icon text-gray-400" />Past
                        PLEDs</router-link
                    >
                </li>
                <li class="sub-sub-menu-item">
                    <router-link
                        class="sub-sub-menu-item-link"
                        :to="{ name: 'SiteAdminGroupMembers', params: { groupId: group.id } }"
                        @click.prevent="gotoRoute({ name: 'SiteAdminGroupMembers', params: { groupId: group.id } })"
                        ><IconUserGroup class="sub-sub-menu-item-icon" />Members</router-link
                    >
                </li>
                <li class="sub-sub-menu-item">
                    <router-link
                        class="sub-sub-menu-item-link"
                        :to="{ name: 'SiteAdminGroupLicences', params: { groupId: group.id } }"
                        @click.prevent="gotoRoute({ name: 'SiteAdminGroupLicences', params: { groupId: group.id } })"
                        ><IconLicence class="sub-sub-menu-item-icon" />Licences</router-link
                    >
                </li>
                <li class="sub-sub-menu-item">
                    <router-link
                        class="sub-sub-menu-item-link"
                        :to="{ name: 'SiteAdminGroupSettings', params: { groupId: group.id } }"
                        @click.prevent="gotoRoute({ name: 'SiteAdminGroupSettings', params: { groupId: group.id } })"
                        ><IconCog class="sub-sub-menu-item-icon" />Settings</router-link
                    >
                </li>
            </template>
        </ul>
        <template v-if="subgroup && subgroup.title">
            <ul class="sub-sub-menu">
                <li class="sub-sub-menu-item">
                    <router-link
                        class="sub-sub-menu-item-link back-link"
                        :to="{ name: 'SiteAdminGroupSubgroups', params: { groupId: group.id } }"
                        @click.prevent="gotoRoute({ name: 'SiteAdminGroupSubgroups', params: { groupId: group.id } })"
                        ><IconService class="sub-sub-menu-item-icon" />All {{ $t("subgroups") }}</router-link
                    >
                </li>
            </ul>
        </template>
        <template v-else-if="group && group.title">
            <ul class="sub-sub-menu">
                <li class="sub-sub-menu-item">
                    <router-link
                        class="sub-sub-menu-item-link back-link"
                        :to="{ name: 'SiteAdminGroups' }"
                        @click.prevent="gotoRoute({ name: 'SiteAdminGroups' })"
                        ><IconOrg class="sub-sub-menu-item-icon" />All Orgs</router-link
                    >
                </li>
            </ul>
        </template>
    </nav>
</template>

<script>
export default {
    name: "SiteAdminGroupingSubSubMenu",
    computed: {
        group() {
            return this.$store.state.admin.currentGroup;
        },
        subgroup() {
            return this.$store.state.admin.currentSubgroup;
        }
    },
    methods: {
        gotoRoute(route) {
            this.$router.push(route);
            this.$store.commit("closeMobileMenu");
        }
    }
};
</script>